import * as API from './'

export default {
  dictCode: params => {
    return API.GET('/api/dict/code', params)
  },
  dictSex: params => {
    return API.GET('/api/dict/sex', params)
  },
  dictCertType: params => {
    return API.GET('/api/dict/certType', params)
  },
  dictStatus: params => {
    return API.GET('/api/dict/status', params)
  },
  dictOrgType: params => {
    return API.GET('/api/dict/orgType', params)
  },
  dictMenuType: params => {
    return API.GET('/api/dict/menuType', params)
  },
  dictShowHide: params => {
    return API.GET('/api/dict/showHide', params)
  },
  dictAgreeType: params => {
    return API.GET('/api/dict/agreeType', params)
  },
  dictRoleType: params => {
    return API.GET('/api/dict/roleType', params)
  },
  dictList: params => {
    return API.GET('/api/dict/list', params)
  },
  dictPageList: params => {
    return API.GET('/api/dict/pageList', params)
  },
  saveDict: params =>{
    return API.POST('/api/dict/save',params)
  },
  updateDict: params =>{
    return API.POST('/api/dict/update',params)
  },
  removeDict: id => {
    return API.GET('/api/dict/remove/' + id)
  },
  /**字典类型相关接口**/
  dictTypeList: params => {
    return API.GET('/api/dictType/list', params)
  },
  dictTypePageList: params => {
    return API.GET('/api/dictType/pageList', params)
  },
  checkDictTypeCode: params => {
    return API.GET('/api/dictType/exists', params)
  },
  saveDictType: params => {
    return API.POST('/api/dictType/save',params)
  },
  updateDictType: params => {
    return API.POST('/api/dictType/update',params)
  },
  removeDictType: id => {
    return API.GET('/api/dictType/remove/' + id)
  },
  combox: code => {
    return API.GET('/api/dict/combox/' + code)
  }
}


// WEBPACK FOOTER //
// ./src/api/api_dict.js